export enum BusinessFeatureEnum {
  Accounts = 'Accounts',
  CRM = 'CRM',
  Shipping = 'Shipping',
  Ordering = 'Ordering',
  Inventory = 'Inventory',
  GPOS = 'GPOS',
  PRODUCTION = 'Production',
}
